import {BigWinModule} from '@fantasmagames/slot/src/modules/bigwin/BigWinModule';
import {GameBigWinPlayingState} from 'src/bigwin/states/GameBigWinPlayingState';
import {GameBigWinPlayingMultiplierState} from 'src/bigwin/states/GameBigWinPlayingMultiplierState';
import {GameBigWinBasicState} from 'src/bigwin/states/GameBigWinBasicState';

export class GameBigWinModule extends BigWinModule {
	public static readonly PLAYINGMULTIPLIER_STATE: string = 'playingmultiplier';

	protected setupStates(): void {
		super.setupStates();

		this.addState(new GameBigWinPlayingState(this, BigWinModule.PLAYING_STATE));
		this.addState(new GameBigWinPlayingMultiplierState(this, GameBigWinModule.PLAYINGMULTIPLIER_STATE));
		this.addState(new GameBigWinBasicState(this, BigWinModule.BASIC_STATE));
	}
}



// WEBPACK FOOTER //
// ./src/bigwin/GameBigWinModule.ts